
import DataGrid from 'components/DataGrid';
import { useAccountingPaymentList } from '../../hooks/useAccountingPayment';
import { Grid } from '@mui/material';
import { BtnSearch, BtnClear } from 'components/Button/ButtonAll';
import { FormProvider } from 'react-hook-form';
import { DatePickerItem } from 'components/Input/DatePicker/DatePickerItem';
import { I18n } from 'utilities/utilities';
import { useMemo, useState } from 'react';
import { MultipleSelectItem } from 'components/Input/Select/MultipleSelectItem';

const AccountingPaymentList = () => {

    //#region Hook
    const {
        formSearch,
        dataColumn,
        getTable,
        onDelete,
        handleClearSearch,
        dataRow,
        loadingTable,
        userType,
        lstStatus,
        nPrmUser,
        lstOptionMuseum
    } = useAccountingPaymentList()
    // #endregion

    const [startDate, setStartDate] = useState(null);
    const dataColumnAcc = useMemo(() => {
        let data = dataColumn;
        if (userType === 1) {
            data.splice(2, 1);
        }
        return data;
    }, [dataColumn, userType])

    return (
        <Grid container spacing={1} justifyContent={'flex-start'}>
            <Grid item xs={12} >
                <FormProvider {...formSearch}>
                    <Grid container spacing={2} justifyContent={"flex-end"} alignItems={"start"}>
                        {userType !== 1 && nPrmUser === 2 && <Grid item xs={12} sm={4} md={5}>
                            <MultipleSelectItem
                                id={"arrMuseum"}
                                name={"arrMuseum"}
                                label={`ชื่อพิพิธภัณฑ์`}
                                required={false}
                                options={lstOptionMuseum}
                                limitTag={1}
                            />
                        </Grid>}
                        <Grid item xs={12} sm={4} md={2}>
                            <DatePickerItem
                                id={`nStartDate`}
                                name={`nStartDate`}
                                label={`วันที่นำฝาก (เริ่มต้น)`}
                                fullWidth
                                onChange={(e) => {
                                    setStartDate(e);
                                    if (e) {
                                        formSearch.setValue("sDateEnd", null);
                                    }
                                }}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <DatePickerItem
                                id={`nEndDate`}
                                name={`nEndDate`}
                                label={`วันที่นำฝาก (สิ้นสุด)`}
                                minDate={startDate}
                                fullWidth
                                disabled={false}
                            />
                        </Grid>
                        <Grid item xs={12} sm={4} md={2}>
                            <MultipleSelectItem
                                id={"arrStatusId"}
                                name={"arrStatusId"}
                                label={`${I18n.SetText("Ticket.Status")}`}
                                required={false}
                                options={lstStatus}
                            />
                        </Grid>
                        <Grid item xs={12} md={'auto'}>
                            <Grid container spacing={1} direction="row" justifyContent="center" alignItems="center" >
                                <Grid item>
                                    <BtnClear id={"btn-clear"} IsCircleWithOutText onClick={() => handleClearSearch()} />
                                </Grid>
                                <Grid item>
                                    <BtnSearch id={"btn-search"} IsCircleWithOutText onClick={() => getTable(dataRow)} />
                                </Grid>
                            </Grid>
                        </Grid>
                    </Grid>
                </FormProvider>
            </Grid>
            <Grid item xs={12} >
                <DataGrid
                    columns={dataColumnAcc}
                    isShowCheckBox={false}
                    rows={dataRow}
                    isLoading={loadingTable}
                    onLoadData={getTable}
                    isHiddenFooter={dataRow.arrRows.length === 0}
                    onDelete={onDelete}
                    sTableID='gtAccpayment'
                    isHiddenToolHead={true}
                // filterField={filterListTicket}
                />
            </Grid>
        </Grid>

    )
}

export default AccountingPaymentList
